export const convertToDateFormat = (glCutoffDate: string): string => {
  if (!glCutoffDate) return '';
  const glCutOffDateArray = glCutoffDate.toString().split(/-/g);
  const shiftArray = glCutOffDateArray.shift();
  if (shiftArray?.length) {
    glCutOffDateArray.push(shiftArray);
  }
  return glCutOffDateArray.join('/');
};
